import { render, staticRenderFns } from "./ApexoButton.vue?vue&type=template&id=4b72fbe8&"
import script from "./ApexoButton.vue?vue&type=script&lang=js&"
export * from "./ApexoButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports